import { render, staticRenderFns } from "./view-advantage-phone.vue?vue&type=template&id=64d175c6&scoped=true&"
import script from "./view-advantage-phone.vue?vue&type=script&lang=js&"
export * from "./view-advantage-phone.vue?vue&type=script&lang=js&"
import style0 from "./view-advantage-phone.vue?vue&type=style&index=0&id=64d175c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d175c6",
  null
  
)

export default component.exports